export enum TagType {
  Primary = 'primary',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  Info = 'info',
}
